import React from 'react';
import Container from 'components/layout/grid/Container';
import HeaderMenu from './HeaderMenu';
import AlertHeaderInfo from './AlertHeaderInfo';

export default function Header() {
  return (
    <div className="Header">
      {/* <AlertHeaderInfo
        link="https://blog.vaidevoala.com.br/protocolos-de-viagem-covid-19/"
        text={
          <>
            <b>Atendimento Coronavírus:</b> Clique aqui e saiba o que fazer para
            evitar prejuízos.
          </>
        }
      /> */}
      <Container>
        <nav className="navbar navbar-expand-lg navbar-dark justify-content-between">
          <HeaderMenu />
        </nav>
      </Container>
    </div>
  );
}
